import './UsersGroupsPage.scss';

import React from 'react';
import { connect } from 'react-redux';
import { routerActions } from 'react-router-redux';
import classNames from 'classnames';
import update from 'immutability-helper';
import ReduxInfiniteScroll from 'redux-infinite-scroll';

import { clearGroup, deleteGroup, emptyGroups, getGroups, getUsersAndSetGroup, postGroupAvatar, postPutGroup, setGroup, updateGroups, updateSearchTerm, updateThumbnailToUpload } from '../store/groups/actions';
import { closeConfirmModal, closeModal, openConfirmModal, openModal } from 'containers/App/store/actions';
import { setAssignment } from 'containers/AssignmentsPage/store/actions';
import { emptyAssignment } from 'containers/AssignmentsPage/store/reducers';

import Card from 'components/Card';
import Content from 'components/Content';
import ContentHeader from 'components/ContentHeader';
import ContentOptions from 'components/ContentOptions';
import ContentOptionsMenu from 'components/ContentOptionsMenu';
import GroupDetailsModal from '../modals/GroupDetailsModal';
import GroupEditModal from '../modals/GroupEditModal';
import LoadingSpinner from 'components/LoadingSpinner';
import ModalConfirm from 'components/ModalConfirm';
import Search from 'components/Search';

import { FILTER_BY_OPTIONS, SORT_BY_OPTIONS } from './constants';
import { MODALS } from 'utils/constants';

class UsersGroupsPage extends React.Component {
    constructor() {
        super();
        this.oldGroup = {};
    }

    componentWillMount() {
        this.props.emptyGroups();
    }

    _loadGroups() {
        if(this.props.groups.isFetching === false) {
            this.props.getGroups();
        }
    }

    _cancelDelete() {
        this.props.closeConfirmModal();
        if(this.props.app.modal === '') {
            this.props.clearGroup();
        }
    }

    _closeGroupEditModal() {
        if(this.props.groups.group.id != null) {
            this.props.setGroup(this.oldGroup);
            this.props.openModal(MODALS.GROUP_DETAILS);
        } else {
            this.props.clearGroup();
            this.props.closeModal();
            this.oldGroup = {};
        }
        this.props.updateThumbnailToUpload(null);
    }

    createAssignmentFromGroup(group) {
        let newAssignmentObj = update(emptyAssignment, {
            groups: { $push: [group] }
        });

        this.props.setAssignment(newAssignmentObj);
        this.props.changeLocation('/assignments/new');
    }

    _openGroupModal(group, modal) {
        if(group != null) {
            if(group.userIds == null || group.userIds.length === 0) {
                this.props.setGroup(group);
            } else {
                this.props.getUsersAndSetGroup(group);
            }
        }
        this.oldGroup = JSON.parse(JSON.stringify(group));
        this.props.openModal(modal);
    }

    /**
     * @desc    Tests for a search term, and dispatches either search action or getSortedGroups action
     * @param   searchTerm (string)
     */
    _handleSearch() {
        let newGroupsObj = update(this.props.groups, {
            pageNumber: {$set: 0},
            hasMore: {$set: true},
            allGroups: {$set: []}
        });
        this.props.updateGroups(newGroupsObj);
        this.props.getGroups();
    }

    /**
     * @desc    Dispatches actions necessary to sort and GET users
     * @param   sortBy
     * @param   sortDirection
     */
    _handleSort(sortBy, sortDirection) {
        let newGroupsObj = update(this.props.groups, {
            pageNumber: {$set: 0},
            sortBy: {$set: sortBy},
            sortDirection: {$set: sortDirection},
            searchTerm: {$set: ''},
            hasMore: {$set: true},
            allGroups: {$set: []}
        });
        this.props.updateGroups(newGroupsObj);
        this.props.getGroups();
    }


    /**
     * @desc    Dispatches actions necessary to filter and GET users
     * @param   filterBy
     */
    _handleFilter(filterBy) {
        let newGroupsObj = update(this.props.groups, {
            pageNumber: {$set: 0},
            filterBy: {$set: filterBy},
            searchTerm: {$set: ''},
            hasMore: {$set: true},
            allGroups: {$set: []}
        });
        this.props.updateGroups(newGroupsObj);
        this.props.getGroups();
    }

    _confirmDelete(group) {
        this.props.setGroup(group);
        this.props.openConfirmModal(MODALS.GROUP_DELETE_CONFIRM);
    }

    _handleDeleteGroup() {
        this.props.deleteGroup(() => {
            this.props.closeConfirmModal();
            this.props.closeModal();
        });
    }

    _handleSaveGroup() {
        let itemExists = this.props.groups.group.id != null;
        if(this.props.groups.thumbnailToUpload != null) {
            this.props.postGroupAvatar(() => {
                if(itemExists === true) {
                    this.props.openModal(MODALS.GROUP_DETAILS);
                } else {
                    this.props.clearGroup();
                    this.props.closeModal();
                    this.props.updateThumbnailToUpload(null);
                }
            });
        } else {
            this.props.postPutGroup(() => {
                if(itemExists === true) {
                    this.props.openModal(MODALS.GROUP_DETAILS);
                } else {
                    this.props.clearGroup();
                    this.props.closeModal();
                }
            });
        }
    }

    _handleThumbnailSelectedToUpload(file) {
        this.props.updateThumbnailToUpload(file);
    }

    render() {
        let { clearGroup, closeModal, groups, openModal, setGroup, updateThumbnailToUpload } = this.props;

        return (
            <Content className="has-tabs">
                <ContentHeader>
                    <Search handleSearch={this._handleSearch.bind(this)}
                            handleSearchTermChange={this.props.updateSearchTerm}
                            value={groups.searchTerm} />

                    <ContentOptions>
                        <ContentOptionsMenu icon="sort"
                                            disabled={groups.searchTerm !== ''}>
                            {SORT_BY_OPTIONS.map((option) => {
                                return (
                                    <div role="button"
                                         className={classNames({'active': groups.searchTerm === '' && option.sortBy === groups.sortBy && option.sortDirection === groups.sortDirection})}
                                         onClick={this._handleSort.bind(this, option.sortBy, option.sortDirection)}
                                         key={option.key}>
                                        {option.text}
                                    </div>
                                )
                            })}
                        </ContentOptionsMenu>
                        <ContentOptionsMenu icon="filter"
                                            disabled={groups.searchTerm !== ''}>
                            {FILTER_BY_OPTIONS.map((option) => {
                                return (
                                    <div role="button"
                                         className={classNames({'active': groups.searchTerm === '' && option.filterBy === groups.filterBy})}
                                         onClick={this._handleFilter.bind(this, option.filterBy)}
                                         key={option.key}>
                                        {option.text}
                                    </div>
                                )
                            })}
                        </ContentOptionsMenu>
                    </ContentOptions>
                </ContentHeader>

                <ReduxInfiniteScroll elementIsScrollable={false}
                                     hasMore={this.props.groups.hasMore}
                                     loadMore={this._loadGroups.bind(this)}
                                     loadingMore={this.props.groups.isFetching === true}
                                     className="cards"
                                     loader={<LoadingSpinner />}>
                    {groups.allGroups.map((group, index) => {
                        return <Card createAssignment={this.createAssignmentFromGroup.bind(this, group)}
                                     item={group}
                                     key={group.id}
                                     handleDelete={this._confirmDelete.bind(this, group)}
                                     onClick={this._openGroupModal.bind(this, group, MODALS.GROUP_DETAILS)}
                                     openEditModal={this._openGroupModal.bind(this, group, MODALS.GROUP_EDIT)}/>
                    })}
                    <div className="card empty"></div>
                    <div className="card empty"></div>
                    <div className="card empty"></div>
                    {groups.hasMore === false ? (
                        <div className="cards__no-more">
                            No more groups to load.
                        </div>
                    ) : null}
                </ReduxInfiniteScroll>

                <GroupDetailsModal closeModal={() => {
                                       clearGroup();
                                       closeModal();
                                       updateThumbnailToUpload(null);
                                       this.oldGroup = {};
                                   }}
                                   deleteGroup={this._confirmDelete.bind(this)}
                                   group={groups.group}
                                   isFetching={groups.isFetchingUsers}
                                   isSaving={groups.isSaving}
                                   openModal={openModal.bind(this)}
                                   show={this.props.app.modal === MODALS.GROUP_DETAILS}/>

                <GroupEditModal closeModal={() => {
                                    clearGroup.bind(this)();
                                    closeModal.bind(this)();
                                    updateThumbnailToUpload(null);
                                    this.oldGroup = {};
                                }}
                                cancelModal={this._closeGroupEditModal.bind(this)}
                                group={groups.group}
                                handleThumbnailSelectedToUpload={this._handleThumbnailSelectedToUpload.bind(this)}
                                isSaving={groups.isSaving}
                                saveGroup={this._handleSaveGroup.bind(this)}
                                setGroup={setGroup.bind(this)}
                                show={this.props.app.modal === MODALS.GROUP_EDIT}
                                thumbnailToUpload={groups.thumbnailToUpload} />

                {/*Modal for confirming delete group*/}
                <ModalConfirm show={this.props.app.modalConfirm === MODALS.GROUP_DELETE_CONFIRM}
                              cancelAction={this._cancelDelete.bind(this)}
                              confirmAction={this._handleDeleteGroup.bind(this)}
                              confirmText="Remove"
                              disabled={groups.isSaving}
                              text="This action will permanently remove your group from the list. If the group is currently in use it will remain attached to its assignment(s)."
                              title="Remove?" />
            </Content>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        app: state.app,
        groups: state.groups
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        changeLocation: (locationString) => dispatch(routerActions.push(locationString)),
        clearGroup: () => dispatch(clearGroup()),
        deleteGroup: (callback) => dispatch(deleteGroup(callback)),
        emptyGroups: () => dispatch(emptyGroups()),
        getGroups: (callback) => dispatch(getGroups(callback)),
        getUsersAndSetGroup: (groupObj) => dispatch(getUsersAndSetGroup(groupObj)),
        closeConfirmModal: () => dispatch(closeConfirmModal()),
        closeModal: () => dispatch(closeModal()),
        openConfirmModal: (modalNameString) => dispatch(openConfirmModal(modalNameString)),
        openModal: (modalNameString) => dispatch(openModal(modalNameString)),
        postGroupAvatar: (callback) => dispatch(postGroupAvatar(callback)),
        postPutGroup: (callback) => dispatch(postPutGroup(callback)),
        setAssignment: (assignmentObj) => dispatch(setAssignment(assignmentObj)),
        setGroup: (groupObj) => dispatch(setGroup(groupObj)),
        updateGroups: (groupsObj) => dispatch(updateGroups(groupsObj)),
        updateSearchTerm: (searchTerm) => dispatch(updateSearchTerm(searchTerm)),
        updateThumbnailToUpload: (file) => dispatch(updateThumbnailToUpload(file))
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(UsersGroupsPage);



// WEBPACK FOOTER //
// ./src/containers/UsersPage/UsersGroupsPage/index.js